<template>
  <div class="height-100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "FaqIndex"
}
</script>

<style scoped>

</style>
